export default __webpack_public_path__ + "static/heroSectionBg-6d38b9f5e5521ba0308135b6c6b0ce07.png";